/**
 * Google reCAPTCHA v3 helper. Waits for grecaptcha to be ready then executes.
 * Returns "" if the site key is missing or the SDK never loaded (dev / offline).
 */
export async function getRecaptchaToken(action = "register") {
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  if (!siteKey) return "";
  if (typeof window === "undefined" || !window.grecaptcha) return "";
  return new Promise((resolve) => {
    try {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute(siteKey, { action })
          .then((token) => resolve(token || ""))
          .catch(() => resolve(""));
      });
    } catch {
      resolve("");
    }
  });
}
